import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import ProductList from '../views/ProductList.vue'
import GalleryNotes from '../views/GalleryNotes.vue'
import GalleryAuthors from '../views/GalleryAuthors.vue'
import ConversionAnalysis from '../views/ConversionAnalysis.vue'
import store from '../store'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'ProductList',
    component: ProductList,
    meta: { requiresAuth: true }
  },
  {
    path: '/gallery/notes',
    name: 'GalleryNotes',
    component: GalleryNotes,
    meta: { requiresAuth: true }
  },
  {
    path: '/gallery/authors',
    name: 'GalleryAuthors',
    component: GalleryAuthors,
    meta: { requiresAuth: true }
  },
  {
    path: '/conversion',
    name: 'ConversionAnalysis',
    component: ConversionAnalysis,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const timers = window.sessionStorage.getItem('timers')
  if (timers) {
    JSON.parse(timers).forEach(timer => clearTimeout(timer))
    window.sessionStorage.removeItem('timers')
  }

  if (to.meta.requiresAuth && !store.state.isAuthenticated) {
    if (window.axiosCancelTokens) {
      window.axiosCancelTokens.forEach(cancel => cancel())
      window.axiosCancelTokens = []
    }
    next('/login')
  } else {
    next()
  }
})

export default router
